import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import $ from 'jquery';
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    $('html, body').animate(
      {
        scrollTop: 0
      },
      600
    );
  }, [pathname]);

  return null;
};

export default ScrollToTop;
